import React from "react";

import { SquarePen } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/src/components/ui/button";

import PageTitle from "../../common/PageTitle";
import Tag from "../../common/tools/Tag";

import type { JSX } from "react";

interface ContentItemHeaderProps {
  title: string;
  imageUrl: string | null | undefined;
  iconName: string | null;
  isOnAir: boolean;
  contentUrl: string | null;
}

function ContentItemHeader({
  title,
  imageUrl,
  iconName,
  isOnAir,
  contentUrl,
}: ContentItemHeaderProps): JSX.Element {
  const { t } = useTranslation("editor-analytics");

  return (
    <div className="flex min-w-0 items-center gap-4">
      {imageUrl ? (
        <img
          alt=""
          className="h-14 w-36 shrink-0 rounded-md object-cover"
          src={imageUrl}
        />
      ) : (
        <div className="bg-muted text-muted-foreground flex h-14 w-36 shrink-0 items-center justify-center rounded-md">
          {iconName ? <i className="material-icons">{iconName}</i> : null}
        </div>
      )}
      <div className="flex min-w-0 flex-col items-start gap-1">
        <div className="flex max-w-full min-w-0 items-center gap-2">
          <PageTitle className="min-w-0">
            <span className="truncate">{title}</span>
          </PageTitle>
          {isOnAir ? <Tag type="live">{t("common:live")}</Tag> : null}
        </div>
        {contentUrl ? (
          <Button asChild size="sm" variant="outline">
            <Link to={contentUrl}>
              <SquarePen />
              {t("contentItem.openContent")}
            </Link>
          </Button>
        ) : null}
      </div>
    </div>
  );
}

export default ContentItemHeader;
